import {BaseComparisonOperator} from "../base-comparison-operator";
import {ILoggerService} from "../../../../../logger/logger.service.interface";
import {Check} from "@sparkware/app-utils";
import {EqualOperator} from "../equal-operator/equal-operator";

export class AnyOfOperator extends BaseComparisonOperator {
    constructor(private _logger: ILoggerService){
        super();
    }

    compare(value1: unknown, value2: unknown): boolean {
        if(!Check.isArray(value2)) {
            this._logger.error(`Any Of Operator: The second parameter should be an array! value2=${value2}`);
            return new EqualOperator().compare(value1, value2);
        }

        return value2.includes(value1);
    }
}